import React from "react";
import { motion } from "framer-motion";
import { Link } from "react-router-dom";
import doctor from "@/assets/Pins1.png";
import { useTranslate } from "@/locales";
import { useLocale } from "@/middleware";
import { routes } from "@/consts";
import { LANG } from "@/types";
import { cn } from "@/lib/utils";

const HeaderPage: React.FC = () => {
  const { locale } = useLocale();
  const { t } = useTranslate(locale);
  return (
    <section
      id="home"
      style={{
        borderBottomLeftRadius: 50,
        borderBottomRightRadius: 50,
      }}
      className="-mt-[80px] text-purple-900 relative mx-auto pt-60 md:pt-0 md:-mt-20 h-[90vh] md:min-h-screen mb-10 flex items-center w-full"
    >
      <div className="container flex flex-col lg:flex-row items-center justify-between mb-10 pb-10">
        <div className="w-full lg:w-1/2 h-full relative mb-12 lg:mb-0 order-1 lg:order-2 hidden lg:block">
          <div className="flex justify-center lg:justify-center relative z-10">
            <motion.img
              initial={{ opacity: 0, y: 50 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 1 }}
              className="rounded-lg z-10 w-full max-w-[800px] h-auto object-cover"
              src={doctor}
              alt="Doctor illustration"
            />
          </div>
        </div>
        <div className="w-[80%] md:w-full lg:w-1/2 z-10 h-full flex md:items-center justify-center lg:justify-start text-center lg:text-right order-1 lg:order-1">
          <div
            className={cn(
              "absolute -z-50",
              locale == LANG.AR ? "right-0 md:right-96" : "left-0 md:left-44"
            )}
          >
            <div
              className={cn(
                "w-[300px] blur-[120px] h-64 z-[2] bg-yellow-100 absolute md:-top-32 rounded-xl",
                locale == LANG.AR ? "md:-left-12" : "md:left-16"
              )}
            />
            <div
              className={cn(
                "w-[250px] blur-[90px] h-64 z-[2] bg-purple-100 absolute md:-top-52 rounded-xl",
                locale == LANG.AR ? "right-0" : "md:left-52"
              )}
            />
            <div
              className={cn(
                "w-[300px] blur-[80px] h-64 z-[1] bg-pink-100 absolute md:-top-52 rounded-full",
                locale == LANG.AR ? "left-20" : "md:left-24"
              )}
            />
          </div>
          <motion.div
            initial={{ opacity: 0, x: -50 }}
            animate={{ opacity: 1, x: 0 }}
            transition={{ duration: 1 }}
            style={{ maxWidth: "470px" }}
            className={locale == LANG.EN ? "text-left" : "text-right"}
          >
            <h3 className="font-normal text-3xl lg:text-5xl mt-4 mb-4 tracking-wide leading-snug">
              <span className="bg-gradient-to-r font-extrabold text-black bg-clip-text">
                {t("flow.raiseRequests")}
              </span>
              ، {t("flow.ReceiveOffers")}،{" "}
              <span className="bg-gradient-to-r text-black bg-clip-text">
                {t("flow.CompareEasily")}
              </span>
            </h3>
            <p className="max-w-[470px] py-4 pb-8 text-lg font-normal lg:text-xl leading-8 mx-auto lg:mr-0 lg:ml-auto">
              {t("general.platformDescription")}{" "}
              <span className="bg-gradient-to-r text-black bg-clip-text font-semibold">
                {t("general.medicalSuppliesPurchase")}
              </span>
            </p>
            <Link to={routes.register} style={{ margin: "auto" }}>
              <motion.div
                whileHover={{ scale: 1.05 }}
                whileTap={{ scale: 0.95 }}
                className="px-6 py-3 bg-black text-center hover:opacity-90 text-white rounded-full font-bold mx-auto lg:mr-0 lg:ml-auto mb-8 lg:mb-0 w-[60%] cursor-pointer"
              >
                {t("actions.startNow")}
              </motion.div>
            </Link>
          </motion.div>
        </div>

        {/* Mobile Image Section */}
        <div className="w-full lg:w-1/2 h-full relative mb-12 lg:mb-0 order-1 lg:order-2 block md:hidden">
          <div className="flex justify-center lg:justify-center relative z-10">
            <img
              className="rounded-lg z-10 w-full max-w-[500px] h-auto object-cover"
              src={doctor}
              alt="Doctor illustration"
            />
          </div>
        </div>
      </div>
    </section>
  );
};

export default HeaderPage;
